<app-notification-block *ngIf="showError && !unsupported">Du har blockerat aviseringar från oss i browsern. Du kan slå på det igen genom att klicka på ikonen till vänster i addressfältet.</app-notification-block>
<app-notification-block *ngIf="showError && unsupported">Din browser stödjer tyvärr inte aviseringar. Vi rekommenderar Firefox eller Chrome.</app-notification-block>
<div class="content">
    <div>
        <b>Tillåt aviseringar</b>
        <span>Få aviseringar för nya meddelanden</span>
    </div>
    <mat-slide-toggle [checked]="!unsupported && subscribed" (change)="activationChange($event)"></mat-slide-toggle>
</div>